"use client";
import _objectWithoutProperties from '@babel/runtime/helpers/objectWithoutProperties';
import * as React from 'react';
import { Icon } from '../../Icon/Icon.web.js';

var _excluded = ["color", "size"];
var IconPhone = function IconPhone(_ref) {
  var _ref$color = _ref.color,
    color = _ref$color === undefined ? 'currentColor' : _ref$color,
    _ref$size = _ref.size,
    sizeProp = _ref$size === undefined ? '24px' : _ref$size,
    props = _objectWithoutProperties(_ref, _excluded);
  var size = sizeProp;
  return /*#__PURE__*/React.createElement(Icon, props, /*#__PURE__*/React.createElement("svg", {
    fill: "none",
    viewBox: "0 0 24 24",
    width: size,
    height: size
  }, /*#__PURE__*/React.createElement("path", {
    fill: color,
    fillRule: "evenodd",
    d: "M5.027 2.582a2 2 0 0 1 2.82 0l.002.002 4.25 4.25-3.258 3.232a6.05 6.05 0 0 0 1.775 3.135l.027.026.026.028a5.9 5.9 0 0 0 3.118 1.787l3.311-3.261 4.178 4.19a2 2 0 0 1 .004 2.795l-2.087 2.177-.001.002a3 3 0 0 1-2.31.915l-.02-.001-.019-.002a16 16 0 0 1-10.06-4.79A16.1 16.1 0 0 1 2.006 7.022l-.003-.025V6.97a3 3 0 0 1 .883-2.249zM6.437 4 4.296 6.14A1 1 0 0 0 4 6.87a14.1 14.1 0 0 0 4.19 8.776l.01.01.01.01a14 14 0 0 0 8.788 4.198 1 1 0 0 0 .753-.305l2.096-2.187-2.762-2.77-1.898 1.869-.002.002a2 2 0 0 1-1.498.578l-.072-.003-.07-.014a7.9 7.9 0 0 1-4.325-2.399 8.05 8.05 0 0 1-2.37-4.324l-.014-.072-.003-.072a2 2 0 0 1 .58-1.5l.004-.005 1.848-1.833z",
    clipRule: "evenodd"
  })));
};

export { IconPhone, IconPhone as default };
